import { Type } from 'class-transformer';

import BaseIvrNode, { EMPTY_NEXT_ID_MESSAGE } from 'src/models/Ivrs/Nodes/baseIvrNode';
import { getMessageTypeClass, MessageRecording, MessageText } from 'src/models/Ivrs/Nodes/message';
import {
  ValidateNested,
  IsString,
  IsOptional,
  IsNumberString,
  IsNotEmpty,
  ArrayNotEmpty,
  MaxLength,
} from 'class-validator';
import { MenuLabelIsUnique } from '../validators/MenuLabelIsUnique';

export default class ThreadMenuNode extends BaseIvrNode {
  @ValidateNested({ each: true })
  @Type(() => Menu)
  @ArrayNotEmpty({ message: 'Select at least one option' })
  @MenuLabelIsUnique({ message: 'Duplicate label. Please use a unique label.' })
  menu: Menu[];

  @IsString()
  @IsOptional()
  language: string;

  @ValidateNested()
  @Type(getMessageTypeClass)
  message: MessageText | MessageRecording;

  @IsString()
  @IsOptional()
  badSelectionNodeId: string;
}

export class Menu {
  @IsNumberString({}, { message: 'Should be a number' })
  dtmf: string;

  @IsNotEmpty()
  @MaxLength(49, { message: 'Please shorten the label to less than 50 characters' })
  label: string;

  @IsString()
  @IsOptional()
  speech: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_NEXT_ID_MESSAGE })
  nextId?: string;
}
